module.exports = __webpack_public_path__ + "static/img/u55.ccb8cc3f.png";